import React from 'react';
import { PresentationHeader } from './PresentationHeader';
import { PresentationPhotoGrid } from './PresentationPhotoGrid';

export const LuceraPresentation = ({ data, photos, videoSrc }) => (
  <div className="space-y-6">
    <div
      className="bg-bg-page rounded-lg border-2 border-brand-primary overflow-hidden"
      data-testid="presentations-content-lucera"
    >
      <PresentationHeader title={data.title} date={data.date} location={data.location} />
      <div className="bg-black flex justify-center">
        <video
          controls
          preload="metadata"
          poster="/lucera1.jpg"
          className="max-w-md w-full h-auto"
          data-testid="presentations-lucera-video"
        >
          <source src={videoSrc} type="video/mp4" />
          Il tuo browser non supporta la riproduzione video.
        </video>
      </div>
    </div>

    <div className="bg-bg-page rounded-lg border-2 border-brand-primary overflow-hidden">
      <div className="p-6 border-b border-border-medium">
        <h3 className="heading-5 text-brand-primary">Galleria Fotografica</h3>
      </div>
      <PresentationPhotoGrid
        photos={photos}
        altPrefix="Presentazione Lucera Circolo Unione"
        testIdPrefix="presentations-lucera-photo"
      />
    </div>
  </div>
);
